import { DownOutlined, FileTextOutlined, LinkOutlined } from "@ant-design/icons";
import React, { useState } from "react";

interface Source {
  title: string;
  url?: string;
}

interface SourcesCitationProps {
  sources: Source[];
}

const SourceLink: React.FC<{ url: string; title?: string }> = ({ url, title }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <>
      <LinkOutlined style={{ color: "#6366F1", fontSize: 14, flexShrink: 0 }} />
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...styles.sourceLink,
          color: hovered ? "#2563EB" : "#000000",
          textDecoration: hovered ? "underline" : "none",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {title || url}
      </a>
    </>
  );
};

const SourcesCitation: React.FC<SourcesCitationProps> = ({ sources }) => {
  const [expanded, setExpanded] = useState(false);

  if (!sources || sources.length === 0) return null;

  return (
    <div style={styles.container}>
      <button type="button" style={styles.header} onClick={() => setExpanded(!expanded)}>
        <FileTextOutlined style={{ color: "#6366F1", fontSize: 14, flexShrink: 0 }} />
        <span style={styles.headerText}>Sources</span>
        <DownOutlined
          style={{
            color: "#6B7280",
            fontSize: 12,
            flexShrink: 0,
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      </button>
      {expanded && (
        <div style={styles.sourceList}>
          {sources.map((source, index) => (
            <div key={index} style={styles.sourceItem}>
              {source.url ? (
                <SourceLink url={source.url} title={source.title} />
              ) : (
                <>
                  <FileTextOutlined style={{ color: "#6366F1", fontSize: 14, flexShrink: 0 }} />
                  <span style={styles.sourceText}>{source.title}</span>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    marginTop: "8px",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "10px 12px",
    cursor: "pointer",
    background: "transparent",
    border: "none",
    fontFamily: "inherit",
    width: "100%",
    outline: "none",
  },
  headerText: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#374151",
    flex: 1,
    textAlign: "left",
  },
  sourceList: {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    borderTop: "1px solid #E5E7EB",
  },
  sourceItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    minWidth: 0,
    borderBottom: "1px solid #F3F4F6",
  },
  sourceLink: {
    fontSize: "13px",
    color: "#000000",
    textDecoration: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    minWidth: 0,
  },
  sourceText: {
    fontSize: "13px",
    color: "#374151",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    minWidth: 0,
  },
};

export default SourcesCitation;
